import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccordionDetails from '@mui/material/AccordionDetails';
import Accordion from '@mui/material/Accordion';
import useShowError from '../../../shared/lib/hooks/useShowError';
import useAuth from '../../../shared/lib/hooks/useAuth';
import { usePostLogisticsResourceVrpMutation } from '../../../entities/logistic/logisticTasks/redux/logisticTasks.api';
import Loading from '../../../shared/ui/Loading/Loading';

import Container from './styles/Container';
import Wrapper from './styles/Wrapper';
import FileUploader from '../../../shared/ui/FileUploader/FileUploader';
import ResultAlert from './components/ResultAlert/ResultAlert';
import SubmitButton from './components/SubmitButton/SubmitButton';

// Текст ошибки при обработке файл/ загрузке и тд
const defaultError = 'Ошибка при обработке файла, попробуйте еще раз';

function CompanyDeliveryOrdersPanel({ company }) {
  const [
    postLogisticsResourceTrigger,
    {
      isError: isErrorPostLogisticsResource,
      isLoading: isLoadingPostLogisticsResource,
      isSuccess: isSuccessPostLogisticsResource,
      data: dataPostLogisticsResource,
      error: errorPostLogisticsResource,
    },
  ] = usePostLogisticsResourceVrpMutation();
  const [ordersFile, setOrdersFile] = useState(null);
  const [vehiclesFile, setVehiclesFile] = useState(null);
  const [costMatrixFile, setCostMatrixFile] = useState(null);
  const showError = useShowError();
  const auth = useAuth();
  const appUserId = useMemo(() => auth?.user?.appUserId, [auth]);
  const companyId = useMemo(() => company?.companyId, [company]);
  const navigate = useNavigate();

  // Фунция для получения текста ошибки по коду ошиибки запроса

  // Обработка нажатия на кнопку "Создать задачу"
  const handleFormButtonClick = useCallback(() => {
    if (vehiclesFile && ordersFile) {
      const formData = new FormData();
      formData.append('vehiclesFile', vehiclesFile, vehiclesFile.name);
      formData.append('ordersFile', ordersFile, ordersFile.name);
      if (costMatrixFile) formData.append('costMatrixFile', costMatrixFile, costMatrixFile.name);

      postLogisticsResourceTrigger({
        body: formData,
        id: appUserId,
      });
    } else {
      showError(defaultError);
    }
  }, [postLogisticsResourceTrigger, ordersFile, appUserId, companyId, vehiclesFile, costMatrixFile]);

  useEffect(() => {
    if (dataPostLogisticsResource) {
      const logisticTaskId = dataPostLogisticsResource?.data?.logisticTaskId;
      if (logisticTaskId) {
        navigate(`/logistics/delivery/${logisticTaskId}/main`);
      }
    }
  }, [dataPostLogisticsResource]);

  return (
    <Container>
      <Accordion sx={{ p: 1, width: '100%' }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography sx={{ fontSize: '18px' }}>Доставка грузов и пассажиров</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {isLoadingPostLogisticsResource ? (
            <Loading />
          ) : (
            <Wrapper>
              <FileUploader
                label="Файл со списком заказов (формат XLSX)"
                accept=".xlsx"
                id="raised-button-file2"
                file={ordersFile}
                setFile={setOrdersFile}
              />
              <FileUploader
                label="Файл со списком ТС (формат XLSX)"
                accept=".xlsx"
                id="raised-button-file3"
                file={vehiclesFile}
                setFile={setVehiclesFile}
              />
              <FileUploader
                label="Файл матрицы стоимости (формат XLSX)"
                accept=".xlsx"
                id="raised-button-file4"
                file={costMatrixFile}
                setFile={setCostMatrixFile}
              />
              <ResultAlert
                isError={isErrorPostLogisticsResource}
                isSuccess={isSuccessPostLogisticsResource}
                errorData={errorPostLogisticsResource?.data}
              />
              <SubmitButton onClick={handleFormButtonClick} disabled={!ordersFile || !vehiclesFile} />
            </Wrapper>
          )}
        </AccordionDetails>
      </Accordion>
    </Container>
  );
}

CompanyDeliveryOrdersPanel.propTypes = {
  company: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])),
};

CompanyDeliveryOrdersPanel.defaultProps = {
  company: null,
};

export default CompanyDeliveryOrdersPanel;
